export default class MapInteractionEvent {
    constructor(type) {
        this.type = type;
    }
}

MapInteractionEvent.CLICK = "MapInteractionEvent.CLICK";